(function() {
window["JST"] = window["JST"] || {};

window["JST"]["flyer-templates.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="templates-index ">\n  <div class="page-header">\n    <h1>Real Estate Flyer Templates</h1>\n  </div>\n  <p>Select a real estate flyer template and start editing it instantly on FlyerCo.</p>\n  <p><b>Real Estate Flyer Template size: 8.5&apos; x 11&apos;</b></p>\n  <p><b>Real Estate Postcard Size: 4&apos; x 6&apos;</b></p>\n  ';
 _.forEach(categories, function (category) { ;
__p += '\n    <h2>' +
((__t = ( category.name )) == null ? '' : __t) +
'</h2>\n    <div class="row templates">\n      ';
 _.forEach(category.templates, function (template) { ;
__p += '\n        <div class="thumbnail">\n          <h3>' +
((__t = ( template.name )) == null ? '' : __t) +
'</h3>\n          <a href="#" class="button-template-choose" data-template-id="' +
((__t = ( template.id )) == null ? '' : __t) +
'"\n            data-toggle="modal" data-target="#signup-modal">\n            <img src="' +
((__t = ( template.thumbnail_url.thumb )) == null ? '' : __t) +
'" alt="' +
((__t = ( category.name )) == null ? '' : __t) +
' ' +
((__t = ( template.name )) == null ? '' : __t) +
'" width="150">\n            <div class="overlay" style="height:' +
((__t = ( 150 * template.height / template.width )) == null ? '' : __t) +
'px">\n              <div><i class="fa fa-check"></i></div>\n            </div>\n          </a>\n        </div>\n      ';
 }) ;
__p += '\n    </div>\n  ';
 }) ;
__p += '\n</div>\n';

}
return __p
}})();